const css = `.analytics-page .charts-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  container-type: inline-size;
  container-name: charts;
  gap: 16px;
}
.analytics-page .charts-container .p-skeleton,
.analytics-page .charts-container .p-card {
  width: var(--row-half) !important;
  height: 447.5px !important;
}
.analytics-page .charts-container .p-skeleton.full-width, .analytics-page .charts-container .p-skeleton.large-chart,
.analytics-page .charts-container .p-card.full-width,
.analytics-page .charts-container .p-card.large-chart {
  width: var(--row-two-thirds) !important;
}
.analytics-page .charts-container .p-skeleton.small-chart,
.analytics-page .charts-container .p-card.small-chart {
  width: var(--row-third-small) !important;
}
.analytics-page .kpi-container {
  container-type: inline-size;
  container-name: kpis;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 16px;
}
.analytics-page .kpi-container .p-card {
  width: var(--row-quarter);
  min-height: 90px;
}
.analytics-page .kpi-container .p-skeleton {
  width: var(--row-quarter) !important;
  min-height: 90px !important;
}

@container charts (max-width: 1200px) {
  .charts-container div.p-card.p-component.large-chart, .charts-container div.p-card.p-component.small-chart,
  .charts-container div.p-skeleton.p-component.large-chart,
  .charts-container div.p-skeleton.p-component.small-chart {
    width: var(--row-half) !important;
  }
}
@container charts (max-width: 900px) {
  .charts-container div.p-card.p-component,
  .charts-container div.p-skeleton.p-component {
    width: 100% !important;
  }
  .charts-container div.p-card.p-component.large-chart, .charts-container div.p-card.p-component.small-chart,
  .charts-container div.p-skeleton.p-component.large-chart,
  .charts-container div.p-skeleton.p-component.small-chart {
    width: 100% !important;
  }
}
@container kpis (max-width: 1024px) {
  .analytics-page .kpi-container .p-card {
    width: var(--row-half);
  }
  .analytics-page .kpi-container .p-skeleton {
    width: var(--row-half) !important;
  }
}
@container kpis (max-width: 520px) {
  .analytics-page .kpi-container .p-card {
    width: 100%;
  }
  .analytics-page .kpi-container .p-skeleton {
    width: 100% !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
